
import { Button } from "@/components/ui/button";
import { ArrowLeft, Building2 } from "lucide-react";
import { VacationMascot } from "@/components/VacationMascot";

interface ReisaanbiederHeaderProps {
  onBackClick: () => void;
}

export const ReisaanbiederHeader = ({ onBackClick }: ReisaanbiederHeaderProps) => {
  return (
    <div className="space-y-4">
      <Button variant="outline" onClick={onBackClick} className="flex items-center gap-2 w-full md:w-auto">
        <ArrowLeft className="h-4 w-4" />
        Terug naar thema's
      </Button>
      
      <div className="flex items-center justify-center gap-4 sm:gap-6">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold bg-gradient-to-r from-blue-600 via-indigo-500 to-purple-500 bg-clip-text text-transparent">
          Reisaanbieders
        </h2>
        <div className="flex-shrink-0">
          <VacationMascot size="small" />
        </div>
      </div>
      
      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-6 rounded-xl border border-blue-200">
        <div className="flex items-center justify-center gap-2">
          <Building2 className="h-5 w-5 text-blue-600" />
          <p className="text-blue-800 text-center font-medium text-lg">
            Zoek vakanties van jouw favoriete reisaanbieder
          </p>
        </div>
      </div>
    </div>
  );
};
